import { Empty, Select } from 'antd';
import { useEffect, useState } from 'react';
import { GrispiInputProps } from '../..';
import { CustomFieldOptionType } from '../../../CustomField/CustomField.type';
import GrispiInputContainer from '../../GrispiInputContainer';
import { checkDuplicatedValuesInOption } from '../GrispiMultiSelectInput/GrispiStandardMultiSelectInput';

type GrispiSelectInputProps = Omit<GrispiInputProps<'SELECT'>, 'type'>;

const transformFormValue = (value: string | number) => {
    if (!value) return;
    if (typeof value === 'string') return value.split(',');
    return value;
};
const transformSelectValue = (value: string | number | (string | number)[]) => {
    if (value) {
        if (Array.isArray(value) && value.length <= 2) return value?.at(-1) ?? value?.at(-2) ?? null;
        if (typeof value === 'string' || typeof value === 'number') return value;
    }
    return null;
};

const GrispiStandardSelectInput = ({
    antdProps,
    containerProps,
    onChange,
    options,
    value,
    ...rest
}: GrispiSelectInputProps) => {
    const [items, setItems] = useState(checkDuplicatedValuesInOption(options, containerProps?.label));
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        if (typeof value === 'string') {
            if (Array.isArray(items) && !items.find((option) => option.value === value)) {
                setItems([...items, { value, label: value } as Omit<CustomFieldOptionType, 'order'>]);
            }
        }
    }, [items, value]);
    const handleSearch = (value: string) => {
        setSearchTerm(value);
    };

    const resetSearch = () => {
        setSearchTerm('');
    };
    const notFoundContent = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>;

    return (
        <>
            <GrispiInputContainer {...containerProps}>
                <Select<string | number | (string | number)[]>
                    allowClear
                    showSearch
                    onChange={(v) => onChange(transformSelectValue(v))}
                    optionFilterProp="label"
                    optionLabelProp="label"
                    options={items}
                    filterOption={(input, option) => {
                        if (typeof option.label === 'string')
                            return option.label.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0;
                        else {
                            return false;
                        }
                    }}
                    value={transformFormValue(value)}
                    notFoundContent={notFoundContent}
                    onDropdownVisibleChange={(_) => {
                        resetSearch();
                    }}
                    onSearch={handleSearch}
                    onSelect={resetSearch}
                    onDeselect={resetSearch}
                    searchValue={searchTerm}
                    {...antdProps}
                    {...rest}
                />
            </GrispiInputContainer>
        </>
    );
};

export default GrispiStandardSelectInput;
